export default class SubWarehouseActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_SUBWAREHOUSE='GET_HELPER_SUBWAREHOUSE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static RESET_LIST='RESET_LIST';

  static submit(){
    return {
      type: SubWarehouseActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: SubWarehouseActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: SubWarehouseActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: SubWarehouseActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: SubWarehouseActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: SubWarehouseActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: SubWarehouseActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: SubWarehouseActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: SubWarehouseActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: SubWarehouseActions.RESET_DATA,
    };
  }
  static resetList(){
    return {
      type: SubWarehouseActions.RESET_LIST,
    };
  }
  static helper(data){
    return {
      type: SubWarehouseActions.GET_HELPER_SUBWAREHOUSE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: SubWarehouseActions.ERROR_SERVER,
      payload: error
    };
  }
}